import type { CatalogService } from '../services/CatalogService';
import { forceMigrate } from '../services/api/migration';

export function handleExportAll(service: CatalogService): void {
  const json = service.exportAllToJSON();
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `prevdrive-catalogos-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function handleFileUpload(
  service: CatalogService,
  file: File,
  onDone: () => void,
): Promise<void> {
  const isCSV = file.name.toLowerCase().endsWith('.csv');
  const isJSON = file.name.toLowerCase().endsWith('.json');

  if (!isCSV && !isJSON) {
    alert('Por favor, selecione um arquivo CSV ou JSON.');
    return;
  }

  try {
    const text = await file.text();

    const result = isJSON
      ? service.importJSON(text, file.name)
      : service.importCSV(text, file.name);

    if (result.success) {
      const msg = `Catálogo importado com sucesso!\nFabricante: ${result.catalog?.vendor}\nFamília: ${result.catalog?.family}\nModelos: ${result.catalog?.models.length}`;
      if (result.warnings.length > 0) {
        alert(`${msg}\n\nAvisos:\n${result.warnings.join('\n')}`);
      } else {
        alert(msg);
      }
      onDone();
    } else {
      alert(`Erro ao importar:\n${result.errors.join('\n')}`);
    }
  } catch {
    alert('Erro ao ler o arquivo.');
  }
}

export async function handleMigrateToCloud(onDone: () => void): Promise<void> {
  if (!confirm('Migrar todos os catálogos locais para a nuvem Supabase?')) return;
  const btn = document.getElementById('btnMigrateToCloud') as HTMLButtonElement;
  if (btn) { btn.disabled = true; btn.textContent = 'Migrando...'; }
  try {
    const result = await forceMigrate();
    const msgs: string[] = [];
    if (result.migrated > 0) msgs.push(`${result.migrated} migrado(s)`);
    if (result.skipped > 0) msgs.push(`${result.skipped} já existente(s) pulado(s)`);
    if (result.errors.length > 0) msgs.push(`${result.errors.length} erro(s): ${result.errors.map(e => e.error).join('; ')}`);
    if (msgs.length > 0) {
      alert(msgs.join('\n'));
    } else {
      alert('Nenhum catálogo novo para migrar.');
    }
    onDone();
  } catch {
    alert('Erro ao conectar com Supabase.');
    onDone();
  }
}